import actingData from "../data/actingData";
import ProductionCard from "../components/ProductionCard";

function Acting() {
  return (
    <div className="page">
      <h1>Acting</h1>
      {actingData.map((item, index) => (
        <ProductionCard key={index} item={item} />
      ))}
    </div>
  );
}

export default Acting;